// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ActiveSpeakerIcon__active-speaker-db49f0 {
  display: inline-block;
  vertical-align: middle;
  overflow: hidden;
  position: relative;
  width: 12px;
  height: 16px;
  margin: 0 6px;
}

.ActiveSpeakerIcon__active-speaker-db49f0:before,
.ActiveSpeakerIcon__active-speaker-db49f0:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 2px;
  transform: translateY(-50%);
  height: 8px;
  border-radius: 1px;
  background-color: var(--addition-90);
  animation: ActiveSpeakerIcon__subspeaker-b18d1f 0.35s linear 0s infinite alternate;
}

.ActiveSpeakerIcon__active-speaker-db49f0:after {
  left: auto;
  right: 0;
}

.ActiveSpeakerIcon__active-speaker-db49f0 .ActiveSpeakerIcon__active-speaker-icon-ba0c93 {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 2px;
  height: 12px;
  border-radius: 1px;
  transform: translate(-50%, -50%);
  background-color: var(--addition-90);
  animation: ActiveSpeakerIcon__speaker-f75ade 0.35s linear 0s infinite alternate;
}

.ActiveSpeakerIcon__active-speaker-big-c8ffbc {
  width: 16px;
  margin: 4px;
}

.ActiveSpeakerIcon__active-speaker-big-c8ffbc .ActiveSpeakerIcon__active-speaker-icon-ba0c93 {
  height: 16px;
  border-radius: 2px;
  width: 4px;
  animation-name: ActiveSpeakerIcon__speaker-big-faec66;
}

.ActiveSpeakerIcon__active-speaker-big-c8ffbc:before,
.ActiveSpeakerIcon__active-speaker-big-c8ffbc:after {
  height: 10px;
  border-radius: 2px;
  width: 4px;
  animation-name: ActiveSpeakerIcon__supspeaker-big-a2d66f;
}

.ActiveSpeakerIcon__silence-bf1667 .ActiveSpeakerIcon__active-speaker-icon-ba0c93,
.ActiveSpeakerIcon__silence-bf1667:before,
.ActiveSpeakerIcon__silence-bf1667:after {
  animation-name: none;
  height: 2px;
}

.ActiveSpeakerIcon__active-speaker-big-c8ffbc.ActiveSpeakerIcon__silence-bf1667 .ActiveSpeakerIcon__active-speaker-icon-ba0c93,
.ActiveSpeakerIcon__active-speaker-big-c8ffbc.ActiveSpeakerIcon__silence-bf1667:before,
.ActiveSpeakerIcon__active-speaker-big-c8ffbc.ActiveSpeakerIcon__silence-bf1667:after {
  height: 4px;
}

@keyframes ActiveSpeakerIcon__subspeaker-b18d1f {
  0% {
    height: 8px;
  }
  100% {
    height: 2px;
  }
}
@keyframes ActiveSpeakerIcon__speaker-f75ade {
  0% {
    height: 12px;
  }
  100% {
    height: 2px;
  }
}
@keyframes ActiveSpeakerIcon__supspeaker-big-a2d66f {
  0% {
    height: 10px;
  }
  100% {
    height: 2px;
  }
}
@keyframes ActiveSpeakerIcon__speaker-big-faec66 {
  0% {
    height: 16px;
  }
  100% {
    height: 2px;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/components/ActiveSpeakerIcon/styles.m.css"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,2BAAA;EACA,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,kFAAA;AACF;;AAEA;EACE,UAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,oCAAA;EACA,+EAAA;AACF;;AAEA;EACE,WAAA;EACA,WAAA;AACF;;AAEA;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,qDAAA;AACF;;AAEA;;EAEE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,wDAAA;AACF;;AAEA;;;EAGE,oBAAA;EACA,WAAA;AACF;;AAEA;;;EAGE,WAAA;AACF;;AAEA;EACE;IACE,WAAA;EACF;EACA;IACE,WAAA;EACF;AACF;AAEA;EACE;IACE,YAAA;EAAF;EAEA;IACE,WAAA;EAAF;AACF;AAGA;EACE;IACE,YAAA;EADF;EAGA;IACE,WAAA;EADF;AACF;AAIA;EACE;IACE,YAAA;EAFF;EAIA;IACE,WAAA;EAFF;AACF","sourcesContent":[".active-speaker {\n  display: inline-block;\n  vertical-align: middle;\n  overflow: hidden;\n  position: relative;\n  width: 12px;\n  height: 16px;\n  margin: 0 6px;\n}\n\n.active-speaker:before,\n.active-speaker:after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 2px;\n  transform: translateY(-50%);\n  height: 8px;\n  border-radius: 1px;\n  background-color: var(--addition-90);\n  animation: subspeaker 0.35s linear 0s infinite alternate;\n}\n\n.active-speaker:after {\n  left: auto;\n  right: 0;\n}\n\n.active-speaker .active-speaker-icon {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 2px;\n  height: 12px;\n  border-radius: 1px;\n  transform: translate(-50%, -50%);\n  background-color: var(--addition-90);\n  animation: speaker 0.35s linear 0s infinite alternate;\n}\n\n.active-speaker-big {\n  width: 16px;\n  margin: 4px;\n}\n\n.active-speaker-big .active-speaker-icon {\n  height: 16px;\n  border-radius: 2px;\n  width: 4px;\n  animation-name: speaker-big;\n}\n\n.active-speaker-big:before,\n.active-speaker-big:after {\n  height: 10px;\n  border-radius: 2px;\n  width: 4px;\n  animation-name: supspeaker-big;\n}\n\n.silence .active-speaker-icon,\n.silence:before,\n.silence:after {\n  animation-name: none;\n  height: 2px;\n}\n\n.active-speaker-big.silence .active-speaker-icon,\n.active-speaker-big.silence:before,\n.active-speaker-big.silence:after {\n  height: 4px;\n}\n\n@keyframes subspeaker {\n  0% {\n    height: 8px;\n  }\n  100% {\n    height: 2px;\n  }\n}\n\n@keyframes speaker {\n  0% {\n    height: 12px;\n  }\n  100% {\n    height: 2px;\n  }\n}\n\n@keyframes supspeaker-big {\n  0% {\n    height: 10px;\n  }\n  100% {\n    height: 2px;\n  }\n}\n\n@keyframes speaker-big {\n  0% {\n    height: 16px;\n  }\n  100% {\n    height: 2px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"active-speaker": `ActiveSpeakerIcon__active-speaker-db49f0`,
	"activeSpeaker": `ActiveSpeakerIcon__active-speaker-db49f0`,
	"subspeaker": `ActiveSpeakerIcon__subspeaker-b18d1f`,
	"active-speaker-icon": `ActiveSpeakerIcon__active-speaker-icon-ba0c93`,
	"activeSpeakerIcon": `ActiveSpeakerIcon__active-speaker-icon-ba0c93`,
	"speaker": `ActiveSpeakerIcon__speaker-f75ade`,
	"active-speaker-big": `ActiveSpeakerIcon__active-speaker-big-c8ffbc`,
	"activeSpeakerBig": `ActiveSpeakerIcon__active-speaker-big-c8ffbc`,
	"speaker-big": `ActiveSpeakerIcon__speaker-big-faec66`,
	"speakerBig": `ActiveSpeakerIcon__speaker-big-faec66`,
	"supspeaker-big": `ActiveSpeakerIcon__supspeaker-big-a2d66f`,
	"supspeakerBig": `ActiveSpeakerIcon__supspeaker-big-a2d66f`,
	"silence": `ActiveSpeakerIcon__silence-bf1667`
};
module.exports = ___CSS_LOADER_EXPORT___;
